import {take, put, call} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes, efServiceCaseTypes} from '@ace-de/eua-entity-types';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import updateServiceCase from '../../service-cases/sagas/updateServiceCase';
import * as sarjActionTypes from '../sarjActionTypes';
import sendAttachmentsWithAssignmentFlow from '../../service-cases/sagas/sendAttachmentsWithAssignmentFlow';

/**
 * Update SARJ cost coverage flow
 */
const updateSARJCostCoverageFlow = function* updateSARJCostCoverageFlow() {
    while (true) {
        const {payload} = yield take(sarjActionTypes.SUBMIT_SARJ_COST_COVERAGE_FORM);
        const {
            serviceAssignmentLineNo,
            serviceAssignmentData,
            serviceCaseId,
            serviceCaseData,
            nonAceMember,
            attachmentsToSendWithAssignment,
        } = payload;

        yield call(sendAttachmentsWithAssignmentFlow, {
            caller: sarjActionTypes.SUBMIT_SARJ_COST_COVERAGE_FORM,
            attachmentsToSendWithAssignment,
            serviceCaseId,
        });

        yield* updateServiceAssignment({
            caller: sarjActionTypes.SUBMIT_SARJ_COST_COVERAGE_FORM,
            assignmentType: efServiceAssignmentTypes.RETURN_JOURNEY,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        if (nonAceMember) {
            yield* updateServiceCase({
                caller: sarjActionTypes.SUBMIT_SARJ_COST_COVERAGE_FORM,
                caseType: efServiceCaseTypes.VEHICLE,
                serviceCaseId,
                serviceCaseData,
            });
        }

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: sarjActionTypes.SUBMIT_SARJ_COST_COVERAGE_FORM},
        });
    }
};

export default updateSARJCostCoverageFlow;
